export default __webpack_public_path__ + "static/media/right_hero_like.77ae8e88.png";